'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createValues = require('./createValues');

var _createValues2 = _interopRequireDefault(_createValues);

var _plain = require('./structure/plain');

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createValues2.default)(_plain2.default);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/values.js
// module id = 755
// module chunks = 0